export default {"src":"/_next/static/media/divider-wave.75294d39.svg","height":1382,"width":6830,"blurWidth":0,"blurHeight":0};